var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.219 11.784L11.784 22.219C11.6042 22.4178 11.5076 22.6781 11.5144 22.9462C11.5211 23.2142 11.6305 23.4693 11.8201 23.6589C12.0097 23.8485 12.2649 23.9579 12.5329 23.9647C12.8009 23.9714 13.0612 23.8748 13.26 23.695L23.695 13.26C23.8749 13.0612 23.9714 12.8008 23.9647 12.5328C23.958 12.2648 23.8485 12.0096 23.659 11.82C23.4694 11.6305 23.2142 11.521 22.9462 11.5143C22.6782 11.5076 22.4179 11.6041 22.219 11.784ZM20.132 0.30498L0.305041 20.132C0.125198 20.3308 0.0286492 20.5911 0.0353622 20.8592C0.0420751 21.1272 0.151537 21.3823 0.341108 21.5719C0.530679 21.7615 0.785858 21.8709 1.05387 21.8777C1.32188 21.8844 1.58222 21.7878 1.78104 21.608L21.608 1.78098C21.7879 1.58216 21.8844 1.32182 21.8777 1.05381C21.871 0.785797 21.7615 0.530618 21.572 0.341047C21.3824 0.151476 21.1272 0.0420141 20.8592 0.0353011C20.5912 0.0285882 20.3309 0.125137 20.132 0.30498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadcn);
export default __webpack_public_path__ + "static/media/shadcn.4b533987317e20d7585f84672e31a1ec.svg";
export { ForwardRef as ReactComponent };